/*---------------------------------------------------*/
/* Add addtional properties to the $location service */
/*---------------------------------------------------*/
/* @ngInject */
export function locationDecorator($delegate, $injector) {
  /*--------------------------------------*/
  /* Add function when ngRoute is present */
  /*--------------------------------------*/
  if ($injector.has('$routeParams'))
    $delegate.pathNoUpdate = $injector.invoke(pathNoUpdate, null, {
      $delegate: $delegate
    });

  return $delegate;
}

/*****************************************************************************
 * pathNoUpdate */
/**
 * Updates the path in the address bar and the associated $routeParams values,
 * if any, without having the route be reloaded due to the location change.
 *
 * This allows for current view and data to be maintained while updating the path.
 *
 * The logic is based on how the $location service and the $route service
 * handle path changes.
 *
 * Note: This uses the $browser service which is meant to be a private api
 *       as documented by Angular.
 *
 * @param  path     String path to set
 * @param  replace  Indication to replace the current path in the browser history
 * @return          Promise that resolves after the path has been changed
 *****************************************************************************/
/* @ngInject */
function pathNoUpdate(
  $browser,
  $delegate,
  $q,
  $rootScope,
  $routeParams,
  $timeout
) {
  return function (path, replace) {
    var defer = $q.defer();

    /*---------------------------------------------*/
    /* Listen for the $routeChangeStart which will */
    /* contain information about the new route     */
    /*---------------------------------------------*/
    var dereg = $rootScope.$on(
      '$routeChangeStart',
      function (event, next, current) {
        /*----------------------------------------------*/
        /* Copy new route information to current route  */
        /* object. The prototype is set to the matching */
        /* route definition from the new route.         */
        /*----------------------------------------------*/
        angular.extend(current, next);
        current.prototype = next.$$route;

        /*--------------------------------*/
        /* Update the $routeParams object */
        /*--------------------------------*/
        angular.copy(current.params, $routeParams);

        /*------------------------------------------------------*/
        /* Preventing default will stop the route and location  */
        /* change which will revert the location back to the    */
        /* previous value. A timeout is needed to wait for the  */
        /* reset of values before the new route data can be set */
        /*------------------------------------------------------*/
        event.preventDefault();

        /*---------------------------------------*/
        /* Get new route data to set after reset */
        /*---------------------------------------*/
        var trimmedEmptyHashUrl = $delegate.absUrl().replace(/(#.+)|#$/, '$1');
        var state = $delegate.$$state;

        $timeout(function () {
          /*-----------------------------------------------------*/
          /* Update location values to use new route information */
          /*-----------------------------------------------------*/
          $delegate.$$parse(trimmedEmptyHashUrl);
          $delegate.$$state = state;

          /*-------------------------------------------------*/
          /* Set the url, if replace is true, this will      */
          /* replace the history stack for the current page. */
          /*-------------------------------------------------*/
          $browser.url(trimmedEmptyHashUrl, replace, state);

          /*---------------------*/
          /* Remove the listener */
          /*---------------------*/
          dereg();

          /*--------------------------*/
          /* Resolve returned promise */
          /*--------------------------*/
          defer.resolve();
        });
      }
    );

    /*-----------------------------------------------------------------*/
    /* Set the new path which will trigger the $routeChangeStart event */
    /*-----------------------------------------------------------------*/
    $delegate.path(path);

    return defer.promise;
  };
}
